<div class="html-container" #htmlContainer [style.color]="widgetConfig.TextColor"
[style.background-color]="widgetConfig.BackgroundColor" [style.margin]="widgetConfig.Margin"></div>
